import homepageStyles from "../../styles/homePage.module.css";

export default function HomePagePill({
  icon,
  title
}: {
  icon: React.ReactNode;
  title: string;
}) {
  return (
    <>
      {icon}
      <p className={homepageStyles.title}>{title}</p>
    </>
  );
}
